import type { IconName } from "@nabble/ui";

export type AccountSectionId = "profile" | "authentication" | "sessions" | "data";

export interface AccountSection {
  id: AccountSectionId;
  label: string;
  icon: IconName;
  subtitle: string;
}

export const ACCOUNT_SECTIONS: AccountSection[] = [
  { id: "profile", label: "Profile", icon: "user", subtitle: "Your name, your emails and your organizations." },
  { id: "authentication", label: "Authentication", icon: "shield", subtitle: "Your password and the second factor you use to sign in." },
  { id: "sessions", label: "Sessions", icon: "monitor", subtitle: "Where you're signed in right now." },
  { id: "data", label: "Your data", icon: "download", subtitle: "Download a copy of your data and make requests about it." },
];

/** Where each view of My account lives. */
export function accountPath(section: AccountSectionId): string {
  return `/account/${section}`;
}
